module.exports = __webpack_public_path__ + "assets/827a6c6a4dbda605fa8fc4bb6f44b73a.png";